export default __webpack_public_path__ + "static/media/ActiveUnion.6466e653.svg";